import Swiper from 'swiper';
const photoSliderEl = document.getElementById('photoslider');
const photoSliderFixed = document.getElementById('photoslider-fixed');
const productHeroSlider = document.getElementById('photoslider-productpage');
const photoSliderCableManagement = document.getElementById(
    'photoslider-cablemanagement'
);

function initDefaultSlider(el) {
    new Swiper(el, {
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        speed: 600,
        slidesPerView: 'auto',
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 10
            },
            1024: {
                slidesPerView: 'auto',
                spaceBetween: 60
            }
        }
    });
}

function initFixedSlider(el) {
    new Swiper(el, {
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        speed: 600,
        slidesPerView: 'auto',
        breakpoints: {
            320: {
                spaceBetween: 10
            },
            1024: {
                spaceBetween: 60
            }
        }
    });
}

function initProductHeroSlider(el) {
    const heroSlider = new Swiper(el, {
        pagination: {
            el: '.swiper-pagination-product',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        speed: 600,
        slidesPerView: 1,
        spaceBetween: 0,
        on: {
            slideChange: function() {
                const slideIndex = this.activeIndex + 1;
                history.replaceState(null, null, `#heroslider-${slideIndex}`);
            }
        }
    });

    const hash = window.location.hash;
    if (hash.startsWith('#heroslider-')) {
        const slideNumber = parseInt(hash.replace('#heroslider-', ''));

        if (!isNaN(slideNumber) && slideNumber > 0) {
            heroSlider.slideTo(slideNumber - 1, 0);
            const heroSliderSection = document.getElementById('hero');
            if (heroSliderSection) {
                heroSliderSection.scrollIntoView();
            }
        }
    }
}

function initCableManagement(el) {
    new Swiper(el, {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        speed: 600,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        breakpoints: {
            320: {
                spaceBetween: 10
            },
            1024: {
                spaceBetween: 60
            }
        }
    });
}

function initPhotoslider() {
    if (photoSliderEl != null) {
        initDefaultSlider(photoSliderEl);
    }

    if (photoSliderFixed != null) {
        initFixedSlider(photoSliderFixed);
    }

    if (productHeroSlider != null) {
        initProductHeroSlider(productHeroSlider);
    }

    if (photoSliderCableManagement != null) {
        initCableManagement(photoSliderCableManagement);
    }
}

export { initDefaultSlider, initPhotoslider, productHeroSlider };
